import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { buttonVariants } from "./ui/button";

interface NavbarAuthButtonsProps {
  isMobile?: boolean;
  onNavigate?: () => void;
}

export function NavbarAuthButtons({ isMobile = false, onNavigate }: NavbarAuthButtonsProps) {
  const navigate = useNavigate();
  const { isSignedIn, user, signOut } = useAuth();

  const handleNavigate = (path: string) => {
    if (onNavigate) onNavigate();
    navigate(path);
  };

  const handleSignOut = async () => {
    await signOut();
    navigate("/");
  };

  if (isMobile) {
    return (
      <>
        {!isSignedIn ? (
          <>
            <button
              onClick={() => handleNavigate("/sign-in")}
              className={`w-[110px] ${buttonVariants({ variant: "ghost" })}`}
            >
              Sign In
            </button>
            <button
              onClick={() => handleNavigate("/waitlist")}
              className={`w-[110px] border ${buttonVariants({ variant: "secondary" })}`}
            >
              Waitlist
            </button>
          </>
        ) : (
          <>
            <button
              onClick={() => handleNavigate("/chat")}
              className={`w-[110px] border ${buttonVariants({ variant: "secondary" })}`}
            >
              Chat
            </button>
            <button
              onClick={() => handleNavigate("/journal")}
              className={`w-[110px] ${buttonVariants({ variant: "ghost" })}`}
            >
              Journal
            </button>
            <div className="mt-4 flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-gradient-to-r from-blue-600 to-purple-600 flex items-center justify-center text-white font-medium">
                {user?.user_metadata?.name?.[0]?.toUpperCase() || user?.email?.[0]?.toUpperCase() || "?"}
              </div>
              <button
                onClick={handleSignOut}
                className={buttonVariants({ variant: "ghost" })}
              >
                Sign Out
              </button>
            </div>
          </>
        )}
      </>
    );
  }

  return (
    <>
      {!isSignedIn ? (
        <>
          <button
            onClick={() => handleNavigate("/sign-in")}
            className={buttonVariants({ variant: "ghost" })}
          >
            Sign In
          </button>
          <button
            onClick={() => handleNavigate("/waitlist")}
            className={`border ${buttonVariants({ variant: "secondary" })}`}
          >
            Waitlist
          </button>
        </>
      ) : (
        <>
          <button
            onClick={() => handleNavigate("/chat")}
            className={`border ${buttonVariants({ variant: "secondary" })}`}
          >
            Chat
          </button>
          <button
            onClick={() => handleNavigate("/journal")}
            className={buttonVariants({ variant: "ghost" })}
          >
            Journal
          </button>
          <div className="relative group">
            <button className="w-10 h-10 rounded-full bg-gradient-to-r from-blue-600 to-purple-600 flex items-center justify-center text-white font-medium hover:opacity-90 transition-opacity">
              {user?.user_metadata?.name?.[0]?.toUpperCase() || user?.email?.[0]?.toUpperCase() || "?"}
            </button>
            <div className="absolute right-0 top-full mt-2 w-48 py-2 backdrop-blur-xl bg-white/90 dark:bg-gray-800/90 rounded-xl shadow-xl border border-white/20 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
              <div className="px-4 py-2 text-sm text-gray-600 dark:text-gray-300 border-b border-gray-200 dark:border-gray-700">
                {user?.email}
              </div>
              <button
                onClick={handleSignOut}
                className="w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
              >
                Sign Out
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}
